import { AgGridReact } from 'ag-grid-react';
import { useEffect, useState } from 'react';
import integrationApi from '../services/integration';
import { Button, Card, Col, Container, Form, Modal, Row } from 'react-bootstrap';

function TaskPage() {
  const [loading, setLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [showCustomerDetail, setShowCustomerDetail] = useState(false);
  const [name, setName] = useState('');
  const [customerData, setCustomerData] = useState([]);
  const [colDefs] = useState([
    {
      headerName: 'STT',
      valueGetter: (params) => (params.node ? params.node.rowIndex + 1 : ''),
      width: 80,
      pinned: 'left', // Cố định cột STT bên trái
    },
    // {
    //   field: 'detail',
    //   headerName: 'Chi tiết',
    //   cellRenderer: (params) => {
    //     return (
    //       <Button
    //         size='sm'
    //         variant='primary'
    //         onClick={() => {
    //           setShowCustomerDetail(true);
    //           getCustomerDetail(params.data.account_id);
    //         }}
    //         className='w-100'
    //       >
    //         Xem
    //       </Button>
    //     );
    //   },
    //   width: 100,
    // },
    {
      field: 'task_name',
      headerName: 'Tên công việc',
      flex: 1,
      minWidth: 650,
    },
    {
      field: 'start_task',
      headerName: 'Ngày bắt đầu',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'end_task',
      headerName: 'Ngày kết thúc',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'name_status',
      headerName: 'Trạng thái',
      minWidth: 150,
      flex: 1,
    },
        {
      field: 'receiver_name',
      headerName: 'Người thực hiện',
      minWidth: 250,
      flex: 1,
    },
  ]);
  const [rowData, setRowData] = useState([]);

  const searchTasks = async (q) => {
    setLoading(true);
    try {
      const data = await integrationApi.queryTasks(q);
      setRowData(data?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const getCustomerDetail = async (customerId) => {
    setCustomerLoading(true);
    try {
      const data = await integrationApi.getCustomerDetail(customerId);
      if (data) {
        setCustomerData(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCustomerLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();

    if (!name) {
      alert('Vui lòng nhập thông tin cần tra cứu');
      return;
    }

    searchTasks({
      name,
      project_id: '64',
    });
  };

  useEffect(() => {
    document.title = 'Tra cứu công việc';
  }, []);

  return (
    <>
      <Container
        style={{
          height: '100vh',
        }}
        fluid
      >
        <Row style={{ height: '10%' }} className='align-items-center'>
          <h2 className='text-center'>TRA CỨU CÔNG VIỆC</h2>
        </Row>
        <Row style={{ height: '15%' }} className='align-items-center'>
          <Col xs={12} md={10}>
            <Form.Control
              className='mb-3'
              type='text'
              placeholder='Nhập thông tin cần tra cứu (giáo viên, xe)'
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </Col>
          <Col>
            <Button
              onClick={handleSearch}
              variant='primary'
              disabled={loading}
              className='w-100 mb-3'
            >
              Tra cứu
            </Button>
          </Col>
        </Row>
        {loading ? (
          <p className='text-center py-5'>Đang tìm kiếm...</p>
        ) : (
          <div className='ag-theme-quartz' style={{ height: '75%' }}>
            {rowData.length ? (
              <AgGridReact rowData={rowData} columnDefs={colDefs} />
            ) : (
              <p className='text-center'>Không có dữ liệu</p>
            )}
          </div>
        )}
      </Container>
      <Modal
        show={showCustomerDetail}
        onHide={() => {
          setShowCustomerDetail(false);
          setCustomerData(null);
        }}
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>Thông tin chi tiết</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {customerLoading ? (
            <p className='text-center'>Đang tải dữ liệu...</p>
          ) : (
            <div>
              <p className='text-danger'>
                - Các điều kiện chưa đáp ứng về cabin điện tử liên hệ NV trực
                cabin, các điều kiện chưa đáp ứng bài kiểm tra liên hệ Giáo viên
                Vương.
                <br />- Các trường hợp dạy DAT ngoài thời gian quy định và Giáo
                viên - xe ngoài Báo cáo 1 cần phải được lập lịch điều chỉnh
                trước khi học DAT.
              </p>
              <Row>
                <Col md={12}>
                  <Card className='mb-3'>
                    <Card.Header>
                      <Card.Title>Thông tin cơ bản</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <p>Tên học viên: {customerData?.mapper?.['account_name']?.display_value || 'N/A'}</p>
                      <p>
                        Mã khoá học:{' '}
                        {customerData?.mapper?.['ma_khoa_csdl']
                          ?.display_value || 'N/A'}
                      </p>
                      <p>
                        Tên khoá học:{' '}
                        {customerData?.mapper?.['khoa_hoc']?.display_value ||
                          'N/A'}
                      </p>
                      <p>
                        Mã học viên:{' '}
                        {customerData?.mapper?.['ma_hoc_vien_theo_csdl']
                          ?.display_value || 'N/A'}
                      </p>
                      <p>
                        Ngày sinh: {customerData?.mapper?.['birthday']?.display_value || 'N/A'}
                      </p>
                      <p>
                        Số CMND/CCCD/HC:{' '}
                        {customerData?.mapper?.['can_cuoc_cong_dan']
                          ?.display_value || 'N/A'}
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={12}>
                  <Card className='mb-3'>
                    <Card.Header>
                      <Card.Title>Thông tin học tập</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <p>
                        <strong>KIỂM TRA 5 MÔN:</strong>{' '}
                        <span
                          className={customerData?.mapper?.['ket_qua_ktra_5_mon'].field_value === '312' ? 'text-success' : ''}
                        >
                          {customerData?.mapper?.['ket_qua_ktra_5_mon']
                            ?.display_value || 'N/A'}
                        </span>
                      </p>
                      <p>
                        <strong>CABIN ĐIỆN TỬ:</strong>{' '}
                        {customerData?.mapper?.['cabin_dt']?.display_value ||
                          'N/A'}
                      </p>
                      <p>
                        <strong>NGÀY KHÁM SỨC KHỎE:</strong>{' '}
                        {customerData?.mapper?.['ngay_kham_suc_khoe']
                            ?.display_value ? (
                          <span
                            className={customerData?.mapper?.['ngay_kham_suc_khoe']
                              ?.field_value === '1' ? 'text-success' : ''}
                          >
                            {customerData?.mapper?.['ngay_kham_suc_khoe']
                              ?.display_value || 'CẦN BỔ SUNG'}
                          </span>
                        ) : (
                          <span className='text-danger'>CẦN BỔ SUNG</span>
                        )}
                      </p>
                      <p>
                        <strong>NGÀY HỌC DAT:</strong>{' '}
                        {customerData?.mapper?.['ngay_hoc_dat']
                          ?.display_value || 'N/A'}
                      </p>
                      <p>
                        <strong>DEADLINE DAT:</strong>{' '}
                        {customerData?.mapper?.['ngay_be_giang']
                          ?.display_value || 'N/A'}
                      </p>
                      <p>
                        <strong>GIÁO VIÊN BC1:</strong>{' '}
                        {customerData?.mapper?.['giao_vien_bc1']
                          ?.display_value || 'N/A'}
                      </p>
                      <p>
                        <strong>XE BC1:</strong>{' '}
                        {customerData?.mapper?.['xe_bc1']?.display_value ||
                          'N/A'}
                      </p>
                      <p>
                        <strong>TIẾN ĐỘ ĐÀO TẠO:</strong>{' '}
                        {customerData?.mapper?.['relation_id']?.display_value ||
                          'N/A'}
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default TaskPage;
